import { Fragment } from "react";
import { ExecutionJob } from "../../../types/ExecutionJob/ExecutionJob";
import { Box, Card, Divider, Stack, Typography } from "@mui/material";
import { CheckRounded, CloseRounded } from "@mui/icons-material";
import { translate } from "../../../services/Translations/translatorService";
import { getCaseDataExecutionError } from "../../../services/executionJobService";
import CaseDataChangePreview from "./CaseDataChangePreview";

type CompletedExecutionJobProps = {
  executionJob: ExecutionJob;
};

export default function CompletedExecutionJob({ executionJob }: CompletedExecutionJobProps) {
  return (
    <Card elevation={1}>
      {executionJob.steps.map((step, index) => {
        const failure = step.actionType === "updateCaseData" && step.status === "failed"
          ? getCaseDataExecutionError(step.error) : null;

        return (
          <Fragment key={step.id}>
            <Stack direction={"row"} spacing={2} sx={{ margin: "1rem", alignItems: "center" }}>
              {step.status === "skipped" && <CloseRounded sx={{ color: "action.disabled" }} />}
              {step.status === "failed" && <CloseRounded sx={{ color: "error.main" }} />}
              {step.status === "completed" && <CheckRounded sx={{ color: "success.main" }} />}
              <Box sx={{ minWidth: 0 }}>
                <Typography>
                  <strong>{translate("executionJob.step.actionType.values." + step.actionType)}</strong>
                </Typography>
                {step.actionType === "updateCaseData" && (
                  <>
                    <Typography variant="caption" color="text.secondary">Vorgeschlagene Änderung</Typography>
                    <CaseDataChangePreview preview={step.payload.preview} />
                    {step.status === "failed" && (
                      <Typography variant="body2" color="error" sx={{ whiteSpace: "pre-wrap" }}>
                        {failure?.message ?? "Die Änderung konnte nicht vollständig verarbeitet werden. Bitte den aktuellen Fall prüfen und die Entwicklung informieren."}
                        {failure && `\nFehlerreferenz: ${failure.reference}`}
                      </Typography>
                    )}
                  </>
                )}
              </Box>
            </Stack>
            {index < executionJob.steps.length - 1 && <Divider />}
          </Fragment>
        );
      })}
    </Card>
  );
}
